<template>
  <section class="cta">
    <div class="cta__content container">
      <div class="btn --fade-in-up --delay-1" data-vertical-ivp-class="--animate">
        <a href="https://gemxx.app.dealmaker.tech/invitations/116b0605-8d30-424c-b826-2cc41b84f1e4/view?tnames=srax"
        target="_blank">
          <button class="button">
            Invest Now
          </button>
        </a>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/cta.scss';
</style>

<script>
export default {
  name: 'cta',
  data() {
    return {
    };
  },
};
</script>